import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Stack,
  Chip
} from '@mui/material';
import {
  ExpandMore,
  HelpOutline,
  ArrowBack,
  CheckCircle
} from '@mui/icons-material';

const FAQ = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState('panel1');

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const faqs = [
    {
      id: 'panel1',
      category: '💳 Tarifs & Abonnement',
      question: 'Dois-je fournir une carte bancaire pour l\'offre gratuite ?',
      answer: 'Non ! L\'offre FREE ne nécessite aucune carte bancaire. Vous pouvez créer jusqu\'à 3 clients, 5 factures et 5 devis par mois gratuitement, sans limite de temps. C\'est parfait pour tester ou les activités occasionnelles.'
    },
    {
      id: 'panel2',
      category: '💰 Tarifs & Abonnement',
      question: 'Combien coûte le plan PRO ?',
      answer: 'Le plan PRO coûte 14,99€ net/mois (TVA non applicable, art. 293 B du CGI). Offre fondateur : 14,99€ à vie pour les 100 premiers abonnés (prix bloqué). Vous bénéficiez de factures/devis/clients illimités, relances automatiques, rapprochement bancaire via import CSV, notes de frais avec validation, et exports comptables.'
    },
    {
      id: 'panel3',
      category: '🔄 Abonnement',
      question: 'Puis-je changer de plan à tout moment ?',
      answer: 'Oui, absolument ! Vous pouvez passer de FREE à PRO en 1 clic. Les changements sont immédiats et vous êtes facturé au prorata. Vous pouvez également annuler à tout moment sans frais cachés.'
    },
    {
      id: 'panel4',
      category: '❌ Annulation',
      question: 'Comment annuler mon abonnement ?',
      answer: 'Depuis vos paramètres, en 1 clic. Pas de justification requise, pas de frais cachés. Vous gardez l\'accès jusqu\'à la fin de votre période payée. C\'est aussi simple que ça.'
    },
    {
      id: 'panel5',
      category: '💸 Remboursement',
      question: 'Remboursement possible ?',
      answer: 'Garantie satisfait ou remboursé 30 jours. Si vous n\'êtes pas satisfait de Facteio, nous vous remboursons intégralement, sans poser de questions.'
    },
    {
      id: 'panel6',
      category: '📊 Réforme 2026',
      question: 'Qu\'est-ce que la facture électronique obligatoire en 2026 ?',
      answer: 'À partir de 2026, toutes les entreprises françaises devront émettre et recevoir des factures électroniques. Facteio est conforme dès maintenant à ces nouvelles règles : format structuré, signature électronique, transmission sécurisée.'
    },
    {
      id: 'panel7',
      category: '✅ Conformité',
      question: 'Facteio est-il vraiment conforme à la loi 2026 ?',
      answer: 'Oui, complètement ! Nous respectons les exigences de la réforme : immutabilité des factures (verrouillage), registre des recettes conforme, format e-invoicing, et mise à jour automatique selon les évolutions légales.'
    },
    {
      id: 'panel8',
      category: '🚀 Prise en main',
      question: 'Est-ce compliqué à utiliser ?',
      answer: 'Absolument pas ! Facteio a été conçu pour être simple. Si vous savez envoyer un email, vous savez utiliser Facteio. L\'interface est claire, sans jargon technique. Et si besoin, je suis là pour vous aider.'
    },
    {
      id: 'panel9',
      category: '👤 Support',
      question: 'Qui répond à mes questions ?',
      answer: 'Moi, Sébastien, le créateur de Facteio. Je réponds personnellement aux emails et questions. Vous n\'aurez pas affaire à un robot ou un support délocalisé. Une vraie personne, des réponses claires.'
    },
    {
      id: 'panel10',
      category: '🎓 Accompagnement',
      question: 'L\'accompagnement personnalisé à 99€, c\'est quoi exactement ?',
      answer: 'C\'est une session d\'1h30 où je vous explique la réforme 2026 selon votre situation, je paramètre votre compte Facteio avec vous, et je réponds à toutes vos questions. Vous repartez serein, prêt pour 2026. C\'est optionnel mais très apprécié !'
    },
    {
      id: 'panel11',
      category: '📈 Limites FREE',
      question: 'Que se passe-t-il si je dépasse les limites du plan FREE ?',
      answer: 'Le logiciel vous bloquera gentiment et vous proposera de passer au plan PRO. Pas de frais cachés, pas de facture surprise. Vous contrôlez tout. Et si vous ne voulez pas upgrader, vous attendez le mois suivant (limites par mois).'
    },
    {
      id: 'panel12',
      category: '🔒 Sécurité',
      question: 'Mes données sont-elles sécurisées ?',
      answer: 'Oui ! Vos données sont chiffrées, hébergées en France, et sauvegardées quotidiennement. Nous respectons le RGPD. Vous pouvez exporter ou supprimer vos données à tout moment. Vos informations vous appartiennent.'
    },
    {
      id: 'panel13',
      category: '💼 Multi-entreprises',
      question: 'Puis-je gérer plusieurs entreprises ?',
      answer: 'Le plan FREE est limité à 3 clients. Le plan PRO permet de gérer autant de clients que vous voulez. Chaque client peut avoir plusieurs factures et devis. Si vous gérez vraiment beaucoup de sociétés, contactez-moi pour un plan sur-mesure.'
    },
    {
      id: 'panel14',
      category: '📄 Export',
      question: 'Puis-je exporter mes factures pour mon comptable ?',
      answer: 'Oui ! En plan PRO, vous pouvez exporter vos données de facturation en PDF, CSV et Excel, ainsi que le registre des recettes en CSV. C\'est conçu pour simplifier la transmission comptable.'
    },
    {
      id: 'panel15',
      category: '🔗 Intégrations',
      question: 'Facteio s\'intègre-t-il avec ma banque ?',
      answer: 'En plan PRO, vous pouvez importer vos opérations bancaires en CSV puis lancer le rapprochement des paiements. Vous réduisez fortement le pointage manuel.'
    },
    {
      id: 'panel16',
      category: '📱 Application mobile',
      question: 'Y a-t-il une application mobile ?',
      answer: 'Pour l\'instant, Facteio est une application web accessible depuis n\'importe quel navigateur (ordinateur, tablette, smartphone). Une app mobile dédiée est prévue pour plus tard selon les retours utilisateurs.'
    },
    {
      id: 'panel17',
      category: '🌍 International',
      question: 'Puis-je facturer des clients à l\'étranger ?',
      answer: 'Oui ! Vous pouvez créer des factures en EUR, USD, GBP avec gestion de la TVA intracommunautaire. Facteio gère les mentions légales adaptées selon le pays du client.'
    },
    {
      id: 'panel18',
      category: '⏰ Délai',
      question: 'Combien de temps faut-il pour être opérationnel ?',
      answer: 'Moins de 5 minutes ! Créez votre compte, ajoutez votre profil d\'entreprise (nom, SIRET, logo), et vous êtes prêt à créer votre première facture. Simple comme bonjour.'
    }
  ];

  return (
    <Box sx={(theme) => ({ minHeight: '100vh', background: theme.palette.background.default })}>
      {/* Header */}
      <Box sx={{ 
        bgcolor: 'linear-gradient(135deg, #1F2937 0%, #4B5563 100%)',
        background: 'linear-gradient(135deg, #1F2937 0%, #4B5563 100%)',
        color: 'white',
        py: 8
      }}>
        <Container maxWidth="lg">
          <Button 
            startIcon={<ArrowBack />} 
            sx={{ color: 'white', mb: 3 }}
            onClick={() => navigate('/')}
          >
            Retour à l'accueil
          </Button>
          <Stack direction="row" spacing={2} alignItems="center" mb={2}>
            <HelpOutline sx={{ fontSize: 64 }} />
            <Typography variant="h2" fontWeight={800}>
              Questions Fréquentes
            </Typography>
          </Stack>
          <Typography variant="h6" sx={{ opacity: 0.9, maxWidth: '800px' }}>
            Toutes les réponses à vos questions sur Facteio, la réforme 2026, et la facturation électronique.
          </Typography>
        </Container>
      </Box>

      {/* FAQ Content */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Stack direction="row" spacing={2} mb={4} flexWrap="wrap">
          <Chip icon={<CheckCircle />} label="18 questions répondues" sx={{ bgcolor: '#E5E8EE', color: '#1F2937' }} />
          <Chip label="💳 Tarifs" sx={{ bgcolor: '#F1F5F9' }} />
          <Chip label="📊 Réforme 2026" sx={{ bgcolor: '#F1F5F9' }} />
          <Chip label="🚀 Utilisation" sx={{ bgcolor: '#F1F5F9' }} />
          <Chip label="🔒 Sécurité" sx={{ bgcolor: '#F1F5F9' }} />
        </Stack>

        <Box sx={{ mb: 6 }}>
          {faqs.map((faq) => (
            <Accordion
              key={faq.id}
              expanded={expanded === faq.id}
              onChange={handleChange(faq.id)}
              sx={{
                mb: 2,
                borderRadius: 2,
                '&:before': { display: 'none' },
                boxShadow: expanded === faq.id ? '0 8px 24px rgba(167, 146, 122, 0.2)' : '0 2px 8px rgba(0,0,0,0.08)',
                border: expanded === faq.id ? '2px solid #A7AFB9' : '1px solid #DCE1E8',
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                sx={{
                  '& .MuiAccordionSummary-content': {
                    my: 2,
                  },
                }}
              >
                <Box>
                  <Chip 
                    label={faq.category} 
                    size="small" 
                    sx={{ mb: 1, bgcolor: expanded === faq.id ? '#E5E8EE' : '#F1F5F9', color: '#1F2937' }}
                  />
                  <Typography variant="h6" fontWeight={600}>
                    {faq.question}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ pt: 0, pb: 3 }}>
                <Typography variant="body1" sx={{ fontSize: '1.05rem', lineHeight: 1.8 }}>
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>

        {/* CTA Bottom */}
        <Box 
          sx={{ 
            p: 6, 
            borderRadius: 4, 
            background: 'linear-gradient(135deg, #F1F5F9 0%, #E5E8EE 100%)',
            textAlign: 'center',
            border: '2px solid #A7AFB9'
          }}
        >
          <Typography variant="h4" fontWeight={700} mb={2}>
            Vous avez encore des questions ?
          </Typography>
          <Typography variant="body1" mb={3} fontSize="1.1rem">
            Je suis là pour vous répondre personnellement, sans jargon.
          </Typography>
          <Button 
            variant="contained" 
            size="large"
            sx={{ px: 5, py: 2, fontSize: '1.1rem', fontWeight: 600, bgcolor: '#1F2937', color: '#fff' }}
            href="mailto:contact@facteio.fr"
          >
            Contactez-moi par email
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default FAQ;
